import React from 'react'
import { Row, Col, } from 'reactstrap'
import PropTypes from 'prop-types'
import ResourceCard from './ResourceCard'

const ResourcesSection = React.forwardRef(({
  resources = [],
  pathname = '',
  zipcode = '',
}, ref) => {
  return <>
    <Row>
      <Col xs={12}>
        <h3 className={'heading-3'} ref={ref}>Resources to Help You</h3>
      </Col>
    </Row>
    <Row className={'mt-3 d-flex justify-content-between'}>
      {
        resources.map((r, idx) => {
          return <Col md={4} xs={12} className={'mt-3 mt-md-0'} key={`es-${idx}`}>
            <ResourceCard 
              cardIconClass={r.type.toLowerCase()}
              cardText={r.description}
              cardTitle={r.title}
              cardLink={r.url}
              pathname={pathname}
              zipcode={zipcode}
            />
          </Col>
        })
      } 
      <Col md={4} xs={12} className={'mt-3 mt-md-0'}>
        <ResourceCard 
          cardIconClass={'search'}
          cardTitle={'Search for more Resources'}
          cardType={'solid'}
          cardLink={'{pathname}?es=1&zip={zip}'}
          pathname={pathname}
          zipcode={zipcode}
        />
      </Col>
    </Row>  
  </>
})

ResourcesSection.displayName = 'ResourcesSection';
ResourcesSection.propTypes = {
  resources: PropTypes.array,
  pathname : PropTypes.string,
  zipcode  : PropTypes.oneOfType([ PropTypes.string, PropTypes.number, ]),
}

export default ResourcesSection
